import LinkGenerator from '@/client/components/LinkGenerator/LinkGenerator';

export { LinkGenerator as default };
